import { DEFAULT_DATE_TIME_FORMAT } from '@iconik-io/core/src/date/date_formats';

import type { AppState } from '../../store/types';

export const selectDateTimeFormat = (state: AppState) => {
  return state.settings.merged.datetime_format || DEFAULT_DATE_TIME_FORMAT;
};
